import { formatChannelPlatformLabel, getChannelDisplayKey } from '../../utils/contactChannels'

const CHANNEL_PILL = {
  zalo:     { label: 'Zalo',     bg: 'bg-[#e3f6e8]', text: 'text-[#1a7a3c]' },
  facebook: { label: 'Facebook', bg: 'bg-[#e8edfb]', text: 'text-[#1535c8]' },
  walking:  { label: 'Walking',  bg: 'bg-[#fff4d6]', text: 'text-[#8a5a00]' },
  web:      { label: 'Web',      bg: 'bg-[#f2f2f2]', text: 'text-[#555]' },
  widget:   { label: 'Web',      bg: 'bg-[#f2f2f2]', text: 'text-[#555]' },
}

export default function ContactChannelBadge({ platform }) {
  const key = getChannelDisplayKey(platform)
  const style = CHANNEL_PILL[key] || {
    label: formatChannelPlatformLabel(platform),
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  }

  return (
    <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${style.bg} ${style.text}`}>
      {style.label}
    </span>
  )
}
